import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  additionalCategories: hasMany('category', { inverse: null }),
  articles: hasMany('article', { inverse: null }),
  assetId: belongsTo('asset', { inverse: null }),
  assetId1: belongsTo('asset', { inverse: null }),
  categories: hasMany('category', { inverse: null }),
  categoryId: belongsTo('category', { inverse: null }),
  categoryId1: belongsTo('category', { inverse: null }),
  categoryId2: belongsTo('category', { inverse: null }),
  categoryId3: belongsTo('category', { inverse: null }),
  categoryId4: belongsTo('category', { inverse: null }),
  channelsAdditive: hasMany('channel', { inverse: null }),
  channelsExcluded: hasMany('channel', { inverse: null }),
  channelsExclusive: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  contributors: hasMany('product-contributor', { inverse: 'product' }),
  customShops: hasMany('custom-shop', { inverse: 'product' }),
  dvdCountryCode: belongsTo('category', { inverse: null }),
  dvdFsk: belongsTo('category', { inverse: null }),
  dvdRatio: belongsTo('category', { inverse: null }),
  dvdSystem: belongsTo('category', { inverse: null }),
  externalValues: hasMany('external-value', { inverse: 'product' }),
  internationalLabel: belongsTo('label', { inverse: null }),
  label: belongsTo('label', { inverse: null }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
  productElements: hasMany('product-element', { inverse: null }),
  productPhysCategoryId1: belongsTo('category', { inverse: null }),
  recommendedProducts: hasMany('product', { inverse: null }),
  recommendedTracks: hasMany('product-track', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  shortUrls: hasMany('short-url', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
  videos: hasMany('asset', { inverse: null }),
});
